import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="pt-20 pb-16">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">关于6080电影网</h1>
          <p className="text-sm text-foreground-500 mb-10">最新电影抢先看，高清不缓冲免费大片</p>

          {/* Brand Introduction */}
          <section className="mb-14">
            <h2 className="font-heading text-xl font-bold text-foreground-900 mb-6">品牌介绍</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  6080电影网成立于2020年，是国内领先的免费电影在线观看平台。我们致力于为广大影迷提供最新、最全、最流畅的电影观看体验，让每一位用户都能随时随地享受高清观影的乐趣。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  我们的平台涵盖了动作片、喜剧片、爱情片、科幻片、恐怖片、动画片等全类型电影资源。新片上映第一时间更新，让您不错过任何一部精彩大片。所有影片均支持高清画质播放，且全程无广告打扰，真正做到极速秒开、畅快观影。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  经过多年的发展，6080电影网已积累了超过1000部精选电影资源，拥有数百万忠实用户。我们始终坚持"用户至上"的理念，不断优化产品体验，努力成为国内最受欢迎的电影在线观看平台。
                </p>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20luxury%20cinema%20interior%20with%20red%20velvet%20seats%2C%20large%20screen%2C%20warm%20ambient%20lighting%2C%20elegant%20design%2C%20cinematographic%20atmosphere%2C%20professional%20architectural%20photography&width=600&height=400&seq=about-cinema&orientation=landscape"
                  alt="6080电影网品牌形象"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </section>

          {/* Reputation / Reviews */}
          <section className="mb-14">
            <h2 className="font-heading text-xl font-bold text-foreground-900 mb-6">用户口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-background-100 rounded-xl p-6">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "6080电影网真的是我见过更新最快的平台了！新片上映当天就能看，而且画质超级清晰，完全不卡顿。强烈推荐给所有喜欢看电影的朋友！"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-primary-200 flex items-center justify-center">
                    <i className="ri-user-3-line text-primary-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">电影爱好者小王</p>
                    <p className="text-xs text-foreground-500">使用2年</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 rounded-xl p-6">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "没有广告这一点真的太赞了！以前用其他平台总是被各种弹窗广告烦得要死，6080完全不存在这个问题，观影体验一级棒。"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-accent-200 flex items-center justify-center">
                    <i className="ri-user-3-line text-accent-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">影迷李先生</p>
                    <p className="text-xs text-foreground-500">使用1年</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 rounded-xl p-6">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "分类很全，从动作到科幻到动画，想看的类型都有。而且影片介绍也很详细，评分也靠谱，帮我省了不少选片时间。每天都在用！"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-secondary-300 flex items-center justify-center">
                    <i className="ri-user-3-line text-secondary-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">追剧达人张女士</p>
                    <p className="text-xs text-foreground-500">使用3年</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="mb-14">
            <h2 className="font-heading text-xl font-bold text-foreground-900 mb-6">联系方式</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-background-100 rounded-xl p-6 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                  <i className="ri-mail-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-sm text-foreground-600">contact@6080dy.com</p>
                </div>
              </div>

              <div className="bg-background-100 rounded-xl p-6 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                  <i className="ri-phone-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服电话</h3>
                  <p className="text-sm text-foreground-600">400-888-6080</p>
                </div>
              </div>

              <div className="bg-background-100 rounded-xl p-6 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-secondary-200 rounded-lg flex-shrink-0">
                  <i className="ri-map-pin-line text-secondary-600 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h3>
                  <p className="text-sm text-foreground-600">北京市朝阳区光华路9号</p>
                </div>
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="mb-14">
            <h2 className="font-heading text-xl font-bold text-foreground-900 mb-6">常见问题</h2>
            <div className="space-y-3">
              {[
                { q: '6080电影网真的免费吗？', a: '是的！6080电影网所有电影资源完全免费在线观看，无需注册，无需付费，打开即看。' },
                { q: '电影画质怎么样？有高清吗？', a: '我们提供1080P高清画质在线观看，画面清晰流畅。同时我们也提供多种清晰度选择，适应不同网络环境。' },
                { q: '新片多久会更新？', a: '新片上映后，我们会在第一时间更新资源，通常在24-48小时内即可观看最新电影。' },
                { q: '观看电影需要下载播放器吗？', a: '不需要！6080电影网采用HTML5技术，直接在浏览器中播放，无需下载任何插件或播放器。' },
                { q: '支持哪些设备观看？', a: '6080电影网完美支持电脑、平板和手机等全终端设备，随时随地都能畅享观影乐趣。' },
              ].map((faq, index) => (
                <details key={index} className="bg-background-100 rounded-xl group">
                  <summary className="px-6 py-4 cursor-pointer text-sm font-medium text-foreground-900 flex items-center justify-between list-none">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </details>
              ))}
            </div>
          </section>

          {/* Newsletter */}
          <section className="bg-background-100 rounded-2xl p-8 md:p-12 text-center">
            <h2 className="font-heading text-xl font-bold text-foreground-900 mb-2">订阅最新电影资讯</h2>
            <p className="text-sm text-foreground-500 mb-6">第一时间获取新片上映通知和独家电影推荐</p>
            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d9nk0mgbdkpk99j7gku0"
              method="POST"
              className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
            >
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱地址"
                required
                className="w-full sm:flex-1 px-5 py-3 rounded-full bg-background-50 text-sm text-foreground-900 outline-none border border-background-300 focus:border-primary-400 transition-colors"
              />
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="visually-hidden-field"
              />
              <button
                type="submit"
                className="whitespace-nowrap px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors"
              >
                订阅
              </button>
            </form>
          </section>
        </div>
      </main>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "6080电影网",
            "url": "https://6080dy.com",
            "description": "6080电影网提供最新电影抢先在线观看，新片上映第一时间更新，高清画质不缓冲，免费无广告，极速秒开。",
            "email": "contact@6080dy.com",
            "telephone": "+86-400-888-6080",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "光华路9号",
              "addressLocality": "北京",
              "addressRegion": "朝阳区",
              "addressCountry": "CN",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              { "@type": "Question", "name": "6080电影网真的免费吗？", "acceptedAnswer": { "@type": "Answer", "text": "是的！6080电影网所有电影资源完全免费在线观看，无需注册，无需付费，打开即看。" } },
              { "@type": "Question", "name": "电影画质怎么样？有高清吗？", "acceptedAnswer": { "@type": "Answer", "text": "我们提供1080P高清画质在线观看，画面清晰流畅。同时我们也提供多种清晰度选择，适应不同网络环境。" } },
              { "@type": "Question", "name": "新片多久会更新？", "acceptedAnswer": { "@type": "Answer", "text": "新片上映后，我们会在第一时间更新资源，通常在24-48小时内即可观看最新电影。" } },
              { "@type": "Question", "name": "观看电影需要下载播放器吗？", "acceptedAnswer": { "@type": "Answer", "text": "不需要！6080电影网采用HTML5技术，直接在浏览器中播放，无需下载任何插件或播放器。" } },
              { "@type": "Question", "name": "支持哪些设备观看？", "acceptedAnswer": { "@type": "Answer", "text": "6080电影网完美支持电脑、平板和手机等全终端设备，随时随地都能畅享观影乐趣。" } },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "关于6080电影网",
            "description": "6080电影网品牌介绍、用户口碑和联系方式。最新电影抢先看，高清不缓冲免费大片。",
            "url": "https://6080dy.com/about",
            "isPartOf": {
              "@type": "WebSite",
              "name": "6080电影网",
              "url": "https://6080dy.com",
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://6080dy.com" },
                { "@type": "ListItem", "position": 2, "name": "关于我们" },
              ],
            },
          }),
        }}
      />
      <Footer />
    </>
  );
}